// AVISO: texto gerado como rascunho inicial para dar um ponto de partida.
// Precisa ser revisado por um advogado (CDC) antes de valer como documento
// legal oficial.
import { createFileRoute } from "@tanstack/react-router";
import { formatPhone, whatsappLink } from "@/lib/format";
import { instagramHandle, useStoreSettings } from "@/lib/settings.functions";
import { requestOriginQuery } from "@/lib/seo.functions";

export const Route = createFileRoute("/trocas-devolucoes")({
  loader: async ({ context }) => ({
    origin: await context.queryClient.ensureQueryData(requestOriginQuery()),
  }),
  head: ({ loaderData }) => {
    const canonicalUrl = loaderData?.origin ? `${loaderData.origin}/trocas-devolucoes` : undefined;
    return {
      meta: [
        { title: "Trocas e Devoluções — Loja EG Elétrica" },
        {
          name: "description",
          content: "Política de trocas, devoluções e direito de arrependimento.",
        },
        ...(canonicalUrl ? [{ property: "og:url", content: canonicalUrl }] : []),
      ],
      links: canonicalUrl ? [{ rel: "canonical", href: canonicalUrl }] : [],
    };
  },
  component: TrocasDevolucoesPage,
});

function TrocasDevolucoesPage() {
  const settings = useStoreSettings();

  return (
    <div className="mx-auto max-w-3xl px-4 py-12">
      <h1 className="font-display text-2xl font-bold text-eg-dark mb-2">Trocas e Devoluções</h1>
      <p className="mb-8 text-sm text-muted-foreground">Última atualização: 31 de julho de 2026.</p>

      <div className="space-y-6 text-sm leading-relaxed text-eg-dark">
        <section>
          <h2 className="mb-2 font-display font-bold">1. Direito de arrependimento (7 dias)</h2>
          <p>
            Como a compra é feita fora de um estabelecimento físico, você tem até{" "}
            <strong>7 dias corridos</strong>, a partir do recebimento do produto, para desistir da
            compra sem precisar justificar o motivo — conforme o Art. 49 do Código de Defesa do
            Consumidor. Nesse caso, devolvemos integralmente o valor pago, incluindo frete, se
            houver.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-display font-bold">2. Como solicitar</h2>
          <p>
            Entre em contato pelo{" "}
            <a
              href={whatsappLink(
                settings.whatsapp_number,
                "Olá! Quero solicitar a troca/devolução do meu pedido.",
              )}
              className="font-semibold text-eg-goldtext underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              WhatsApp
            </a>{" "}
            informando o número do pedido e o motivo. Vamos te orientar sobre o envio do produto de
            volta.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-display font-bold">3. Condições do produto</h2>
          <p>
            Para arrependimento (sem defeito), o produto deve ser devolvido na embalagem original,
            sem sinais de uso e com todos os acessórios e manuais que acompanham o item.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-display font-bold">4. Produtos com defeito</h2>
          <p>
            Produtos com defeito de fabricação têm garantia legal de 90 dias (bens duráveis),
            conforme o Art. 26 do CDC, além da garantia do fabricante, quando aplicável. Nesse caso,
            você pode escolher entre reparo, troca por produto igual ou devolução do valor pago.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-display font-bold">5. Produtos sob orçamento/personalizados</h2>
          <p>
            Painéis da linha "Sob Medida", fabricados especificamente para sua necessidade, seguem
            condições de troca combinadas individualmente no orçamento, já que são feitos por
            encomenda.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-display font-bold">6. Reembolso</h2>
          <p>
            Após recebermos e conferirmos o produto devolvido, o reembolso é feito no mesmo meio de
            pagamento utilizado na compra, em até 10 dias úteis.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-display font-bold">7. Frete de devolução</h2>
          <p>
            Em caso de arrependimento ou desistência sem defeito, o custo do frete de devolução é
            por conta do cliente. Em caso de defeito ou erro no envio, o frete de devolução é por
            nossa conta.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-display font-bold">8. Contato</h2>
          <p>
            Dúvidas sobre trocas e devoluções: WhatsApp{" "}
            {formatPhone(settings.whatsapp_number.slice(-11))} ou{" "}
            {instagramHandle(settings.instagram_url)} no Instagram.
          </p>
        </section>
      </div>
    </div>
  );
}
